import { computed, ref } from 'vue'

const MAX_MEASUREMENTS = 20
const measurements = ref<number[]>([])

/**
 * *(AI-generated)*
 * Composable for measuring and tracking frames-per-second (FPS) over a rolling window.
 */
export const useMeasureFps = () => {
  const handleFpsMeasurement = (fps: number) => {
    measurements.value.unshift(fps)
    if (measurements.value.length > MAX_MEASUREMENTS) {
      measurements.value.pop()
    }
  }

  const currentFps = computed(() => {
    return measurements.value[0]
  })

  const averageFps = computed(() => {
    return measurements.value.length
      ? Math.round(
          measurements.value.reduce(
            (sum: number, fps: number) => sum + fps,
            0
          ) / measurements.value.length
        )
      : 0
  })

  return { handleFpsMeasurement, currentFps, averageFps }
}
